// reducer
// import { initialState } from "@/store/MyCalendar/state";

export const myCalendarUpcomingEvents = (state, data) => {
  state.MyCalendar.myCalendarUpcomingEvents = data;
};
